export function handleCacheBusting(caches: CacheStorage) {
  // JEŻELI TO DEVELOPMENT ENVIRONMENT
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    // INFO ZE WERSJA JEST AKTUALNA
    console.log('DEVELOPMENT ENV => NOT CHECKING CACHE');
  }

  // JEŻELI TO PRODUKCJA
  else {
    fetch('/meta.json')
      .then((response: any) => response.json())
      .then((meta: any) => {
        // ZBIERAMY INFORMACJE O WERSJACH
        const latestAppVersionId: number = meta.APP_VERSION_ID;
        const currentAppVersionId: number = Number(process.env.APP_VERSION_ID);
        console.log('Checking app version ...');
        console.log(`latestAppVersionId: ${latestAppVersionId}`);
        console.log(`currentAppVersionId: ${currentAppVersionId}`);

        // SPRAWDZAMY CZY MUSI BYĆ RELOAD ZROBIONY

        // JEŻELI WERSJA NAJNOWSZA JEST NOWSZA NIŻ OBECNA WERSJA
        if (latestAppVersionId > currentAppVersionId) {
          // INFO ZE WERSJA NIE JEST AKTUALNA
          console.log('SITE VERSION: UPDATE REQUIRED');

          // USUWANIE CACHE PRZEGLĄDARKI
          if (caches) {
            caches.keys().then((names: string[]) => {
              for (let name of names) caches.delete(name);
            });
          }

          // RELOADOWANIE I USUWANIE CACHE PRZEGLĄDARKI
          window.location.reload(true);
        }

        // JEŻELI WERSJA JEST AKTUALNA
        else {
          // INFO ZE WERSJA JEST AKTUALNA
          console.log('SITE VERSION: UP TO DATE');
        }
      })
  }

}


// WEBPACK FOOTER //
// ./src/services/cache-busting-service.ts